/**
 * Created by agengmaulana on 4/25/17.
 */
import React from 'react'
import {observable, autorunAsync, action, reaction} from 'mobx'
import 'moment/locale/id';
import $ from 'jquery'

export default class Datastore extends React.Component {


    @observable datastores = []
    @observable profile = []
    @observable paging = []
    @observable position =''
    @observable anchor =''
    @observable anchormaster =''
    @observable wording = 'Belum ada komentar.'
    @observable wording2 = 'Jadilah yang pertama berkomentar di sini'
    @observable dataShort = ''
    @observable gagalload = false
    @observable gagalloadpilred = false
    @observable countComment = 0
    @observable countCommentPro = 0
    @observable countCommentKon = 0
    @observable inshowhide = true
    // @observable Ads =[]
    /* Form Configuration */
    @observable rows = []

    @observable datastoresKomentar = []
    @observable getDataVerifiedId = []
    @observable getDataVerifiedIdPilred = []
    @observable hasAdsAsync = false
    @observable formStore = ''
    @observable datastoresModeration = []
    @observable datastoresModerationChild = []
    @observable datastoresVerified = {}

    /*--------------*/

    /* Show Children Comment Configuration */

    @observable configKomentar = {}

    /*--------------*/

    /* Show Report Abuse */

    // @observable loading = false
    @observable loadingRow = true
    @observable valueLaporkan = ''
    @observable muncul = ''
    /*---------------*/

    /* SweetAlert */
    @observable show = false
    @observable text = ''
    @observable title = ''
    @observable sort = 'ASC'
    @observable doc = ''
    @observable varchar = 'Terbaru'
    /*--------------*/

    ListReport = ["Penyalahgunaan_Akun", "Menghasut", "Ucapan_penghinaan / kebencian", "Spam"];

    ListFilters = ["Terbaru", "Terlama", "Terpopuler", "Teramai", "Komentar_Pilihan"];

    @observable setFilters = 'newest'
    @observable setFiltersProkontra = ''

    /* url komentar */
    @observable win_loc = window.location.hostname.replace(/www./,'')
    @observable parser_loc = this.win_loc.substring(this.win_loc.lastIndexOf(".", this.win_loc.lastIndexOf(".") - 1) + 1)
    @observable url_api_comment = window.location.hostname.search(/(detik)/gi)>-1?'https://apicomment.detik.com/':window.location.protocol+'//apicomment.'+this.parser_loc+'/'
    

    ChangeListFilters(ListFilters) {
        this.ListFilters = ListFilters;
        this.fetchDataKomentar(this.position,ListFilters,undefined,true)
    }

    parsingURL(url){
        var hash = url.substring(url.indexOf("#cmt")+1);
        var sechash = ''
        if(url.indexOf("#cmt") != -1) {
            sechash = hash.substring(3)
        }
        return sechash

    }

    handleSelect=(eventKey)=>{
        this.anchor = ''
        this.anchormaster = ''
        this.position = eventKey
        this.loadingRow = true
        var filters = this.setFilters
        if(this.configKomentar.prokontra == 1){
            var filtersprokontra = this.setFiltersProkontra
            this.fetchDataKomentarProkontra(eventKey,filtersprokontra,'',true)
        }
        else {
            this.fetchDataKomentar(eventKey,filters,'',true)
        }
        // if(this.anchor == ''){
        setTimeout(()=>{

            this.configKomentar.onscroll('#form0')
            this.configKomentar.onresize()
        },1000)
        // }
    }

    isInt(value) {
        if (isNaN(value)) {
            return false;
        }
        var x = parseFloat(value);
        return (x | 0) === x;
    }

    fetchDataKomentar(page,sort,anchorpage,call_verified=false) {
        var getpage = page
        var sorting = sort
        var sortingFilter = 'newest'
        var addpilred =''
        var size = 10
        var query= [
                    {   name: 'news.artikel',
                        terms: this.configKomentar.identifier,
                    },{
                        name: 'news.site',
                        terms: this.configKomentar.site,
                    }
                    ];
        if(sorting == 'undefined'){
            sortingFilter = 'newest'
            sorting = this.setFilters
            page = 1

        }
        else if(sorting == 'Terbaru'){
            sortingFilter = 'newest'
            this.setFilters = 'newest'
            page = 1

        }
        else if(sorting == 'Terlama'){
            sortingFilter = 'oldest'
            this.setFilters = 'oldest'

            page = 1
        }
        else if(sorting == 'Terpopuler'){
            sortingFilter = 'like'
            this.setFilters = 'like'
            page = 1
            this.wording = 'Belum ada komentar.'
            this.wording2 = 'Ayo like/rekomendasikan komentar pembaca sekarang juga'
        }
        else if(sorting == 'Teramai'){
            sortingFilter = 'reply'
            this.setFilters = 'reply'
            page = 1
            this.wording = 'Belum ada komentar.'
            this.wording2 = 'Ayo tanggapi komentar pembaca sekarang juga'

        }
        else if(sorting == 'Komentar Pilihan'){
            sortingFilter = 'pilihanredaksi' // prokontra_label
            this.setFilters = 'pilihanredaksi'
            page = 1
            query.push({name: "pilihanredaksi", terms: "true"})
            this.wording = 'Belum ada komentar.'
            this.wording2 = 'Ayo kirimkan komentar positif Anda kepada pembaca sekarang juga'
        }

        var anchor_qtype =''
        var anchor_qinput = ''
        var anchor_var
        if (this.isInt(this.anchor) === true ){
            anchor_qtype = '$anchor: Int!,'
            anchor_qinput = 'idcomment: $anchor, '
            anchor_var = this.anchor
        }else if(this.isInt(anchorpage) === true){
            anchor_qtype = '$anchor: Int!,'
            anchor_qinput = 'idcomment: $anchor, '
            anchor_var = anchorpage
        }else if (this.isInt(this.anchor) == true && this.isInt(anchorpage) == true){
            anchor_qtype = '$anchor: Int!,'
            anchor_qinput = 'idcomment: $anchor, '
            anchor_var = anchorpage
        }else{
            anchor_qtype = '$anchor: Int!,'
            anchor_qinput = 'page: $anchor, '
            anchor_var = page
        }
        var variabel_input ={
            type : "comment",
            sort : this.setFilters,
            size : size,
            anchor: anchor_var,
            query: query
        }
        var adsLabel = this.configKomentar.kanalAds ? '$adsLabelKanal: String,':''
        var adsEnv = this.configKomentar.envAds ? '$adsEnv: String,':''
        var adsparam = ''
        var hasAds = ''
        var ads_qtype= ''
        if (adsLabel != '' && adsEnv != ''){
            adsparam = 'adsLabelKanal: $adsLabelKanal,'+' '+'adsEnv: $adsEnv,'
            ads_qtype = adsLabel+' '+adsEnv
            hasAds = 'hasAds'
            variabel_input['adsLabelKanal']= this.configKomentar.kanalAds
            variabel_input['adsEnv'] = this.configKomentar.envAds
        }

        var query_request = `query search($type: String!, $size: Int!,${anchor_qtype} $sort: String!, ${ads_qtype} $query: [ElasticSearchAggregation]) {
                                search(type: $type, size: $size,${anchor_qinput}sort: $sort,${adsparam} query: $query){
                                    paging sorting counter counterparent profile hits {
                                        posisi ${hasAds} results {
                                            id author content like prokontra  status news create_date pilihanredaksi refer liker { id } reporter { id status_report } child { id child parent author content like prokontra status create_date pilihanredaksi refer liker { id } reporter { id status_report } authorRefer } } } }}`;
        var urls = this.url_api_comment +'graphql'
        fetch(urls,{
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                query:query_request,
                variables: variabel_input
            })
        })
            .then( (status) => {

                return status
            })
            .then( (response) => {
                const hasError = (response.status < 200 || response.status >= 300)
                if (hasError) {
                    this.gagalload = true
                    throw response.text();
                }
                return  response.json()
            })
            .then( (json) => {
                if(json.data.search == null){
                    this.gagalload = true
                    this.loadingRow = false
                }
                else {
                    this.loadingRow = false
                    this.countComment = json.data.search.counter
                    this.profile = json.data.search.profile
                    this.datastoresKomentar = json.data.search.hits.results
                    this.getDataVerifiedId = this.setVerifiedId(json.data.search.hits.results)
                    this.paging = json.data.search.paging
                    this.position = json.data.search.hits.posisi
                    if (adsLabel === '' && adsEnv === ''){
                        this.hasAdsAsync = false
                        if(this.configKomentar.data_oa != null){
                            this.getAds(json.data.search.hits.posisi)
                        }
                    }else{
                        this.hasAdsAsync = json.data.search.hits.hasAds
                    }
                    if(this.formStore !=''){
                        setTimeout(()=>{
                            this.configKomentar.onscroll('#form0')
                        },700)
                    }
                    else if(this.anchor !=''){
                        setTimeout(()=> {
                            // console.log(this.anchor);
                            this.configKomentar.onscroll(this.anchor)
                        },700)
                    }
                    if(call_verified){
                        var dataVerifiedId = this.getDataVerifiedId.map(function(data){return data})
                        var dataVerifiedIdPilred = this.getDataVerifiedIdPilred.map(function(data){return data})
                        var merge = dataVerifiedId.concat(dataVerifiedIdPilred)
                        var distinct = this.distincArray(merge)
                        this.fetchDataVerifiedUser(distinct)
                    }
                }
                setTimeout(()=>{
                    this.configKomentar.onresize()

                },1200)
            }).catch((error) => {

        })

    }

    getAds(a){

        var showads1 = this.configKomentar.data_oa('1')
        var showads2 = this.configKomentar.data_oa('2')
        var showads3 = this.configKomentar.data_oa('3')
        var showads4 = this.configKomentar.data_oa('4')
        var showads5 = this.configKomentar.data_oa('5')
        var showads6 = this.configKomentar.data_oa('6')
        var showads7 = this.configKomentar.data_oa('7')
        var showads8 = this.configKomentar.data_oa('8')
        var showads9 = this.configKomentar.data_oa('9')
        var showads10 = this.configKomentar.data_oa('10')

        setTimeout(function() {
            $(document).ready(function() {

                if(a == 1){
                    $('#iklan').html( showads1.value);
                    $('#iklan2').html( showads2.value);

                }
                else if(a == 2){
                    $('#iklan').html( showads3.value);
                    $('#iklan2').html( showads4.value);
                }
                else if(a == 3){
                    $('#iklan').html( showads5.value);
                    $('#iklan2').html( showads6.value);
                }
                else if(a == 4){
                    $('#iklan').html( showads7.value);
                    $('#iklan2').html( showads8.value);
                }
                else if(a == 5){
                    $('#iklan').html( showads9.value);
                    $('#iklan2').html( showads10.value);
                }
            })

        },1000)

    }

    fetchData() {

        var variables = {
            type : 'comment',
            articleid : this.configKomentar.identifier,
            site: this.configKomentar.site
        };
        var query = `query pilihanredaksi($type: String!, $articleid: String!, $site: String!) {
          pilihanredaksi(type: $type, articleid: $articleid, site: $site){ hits } }`;
        var urls = this.url_api_comment +'graphql'
        fetch(urls,{
            // credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: variables
            })
        })
            .then( (status) => {
                return status
            })
            .then( (response) => {
                this.refreshButton = true
                return  response.json()
            })
            .then( (json) => {
                this.datastores = json.data.pilihanredaksi.hits;
                this.getDataVerifiedIdPilred = this.setVerifiedId(json.data.pilihanredaksi.hits)
            }).catch(function(error) {
            console.log('An error occurred : ', error);
        })
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    setVerifiedId(data){
        var list_id = []
        for(var i = 0; i < data.length; i++) {
            list_id.push(data[i]['author']['uniqueid']);
            if(typeof data[i]['child'] !== 'undefined'){
                if(data[i]['child'].length > 0){
                    for(var s = 0; s < data[i]['child'].length; s++){
                        list_id.push(data[i]['child'][s]['author']['uniqueid'])
                    }
                }
            }
        }
        var distinct_id = list_id.filter(this.onlyUnique)
        return distinct_id
    }

    distincArray(array){
        var distinct = array.filter(this.onlyUnique)
        return distinct
    }

    remap(data){
        var observer_datastoresVerified = observable.shallowMap(this.datastoresVerified).toJS()
        Object.keys(data).forEach(function(key,index) {
            observer_datastoresVerified[key] = data[key]
        });
        this.datastoresVerified = observer_datastoresVerified
    }


    fetchDataVerifiedUser(idCheckVerified) {
        var variables = {
            id: idCheckVerified
        };
        var query = `query verifieduser($id: [Int]!) {
          verifieduser(search: $id){ result } }`;
        var urls = this.url_api_comment +'graphql'
        var result = {}
        fetch(urls,{
            // credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: variables
            })
            }).then( (status) => {
                return status
            }).then( (response) => {
                return  response.json()
            }).then( (json) => {
                this.remap(json.data.verifieduser.result)
            }).catch(function(error) {
                console.log('An error occurred : ', error);
            })
    }

    addKomentarChild=(id,parent_id,content,refer_id,moderasi)=> {
        var moment = require('moment');
        var convert = moment().unix();

        const datachild = {
            "id":  id,
            "article_id": this.configKomentar.identifier,
            "author": {
                "id":  this.profile.id,
                "name": this.profile.fullname,
                "email": this.profile.email,
                "photo": this.profile.image
            },
            "child":[],
            "like": 0,
            "content": content,
            "create_date": convert,
            "parent": parent_id,
            "authorRefer": [],
            "reporter":[],
            "liker":[],
            "mod":true,
            "moderasi":moderasi
        }
        var dt = JSON.stringify(this.datastoresKomentar)
        var datac = JSON.parse(dt)
        var index = datac.map(function(d) {

            return d['id'];

        }).indexOf(parent_id)
        this.datastoresKomentar[index]['child'].push(datachild)

    }

    addKomentar=(content,id,moderasi)=> {

        var moment = require('moment');
        var convert = moment().unix();

        const dataKomentar = {
            "id":  id,
            "article_id": this.configKomentar.identifier,
            "child": [],
            "author": {
                "id":  this.profile.id,
                "name": this.profile.fullname,
                "email": this.profile.email,
                "photo": this.profile.image
            },
            "like": 0,
            "content": content,
            "create_date": convert,
            "status": 3,
            "parent": null,
            "authorRefer": [],
            "liker":[],
            "mod":true,
            "moderasi":moderasi
        }

        this.datastoresModeration.unshift(dataKomentar);


    }

    addKomentarProkontra=(content,id,label,moderasi)=> {

        var moment = require('moment');
        var convert = moment().unix();

        const dataProkontra = {
            "id":  id,
            "article_id": this.configKomentar.identifier,
            "child": [],
            "author": {
                "id":  this.profile.id,
                "name": this.profile.fullname,
                "email": this.profile.email,
                "photo": this.profile.image
            },
            "like": 0,
            "prokontra": 1,
            "prokontra_label": label,
            "content": content,
            "create_date": convert,
            "status": 3,
            "parent": null,
            "authorRefer": [],
            "liker":[],
            "mod":true,
            "moderasi":moderasi
        }

        this.datastoresModeration.unshift(dataProkontra);


    }

    shareFb=(content,id)=>{

        var parseunicode = content;
        var r = /\\u([\d\w]{4})/gi;
        parseunicode = parseunicode.replace(r, function (match, grp) {
            return String.fromCharCode(parseInt(grp, 16)); } );
        parseunicode = unescape(parseunicode);

        var shareFb = {
            method: 'feed',
            display: 'popup',
            link: this.configKomentar.url_share+"#cmt"+id,
            name: this.configKomentar.title,
            quote: parseunicode
        };
        FB.ui(shareFb);

    }

    dataShortUrl=(content,id)=>{

        var that = this
        var twAPI = "https://twitter.com/intent/tweet"
        let url = encodeURIComponent(this.configKomentar.url_share+"#cmt"+id);
        if(this.configKomentar.site == 'cnn') {
            var parseunicode = content;
            var r = /\\u([\d\w]{4})/gi;
            parseunicode = parseunicode.replace(r, function (match, grp) {
                return String.fromCharCode(parseInt(grp, 16)); } );
            parseunicode = unescape(parseunicode);
            var length = parseunicode.length >= 114 ? '...' : ''
            var substr = parseunicode.substr(0,114)
            let urlcnn = encodeURIComponent("http://cnn.id/"+this.configKomentar.identifier+"#cmt"+id);
            window.open(twAPI+"?text="+substr+length+"&url="+urlcnn,
                "scrollbars=yes,resizable=yes,toolbar=no,location=yes", "width=550,height=320"

            );
        }
        else {
            var parseunicode = content;
            var r = /\\u([\d\w]{4})/gi;
            parseunicode = parseunicode.replace(r, function (match, grp) {
                return String.fromCharCode(parseInt(grp, 16)); } );
            parseunicode = unescape(parseunicode);

            var length = parseunicode.length >= 114 ? '...' : ''
            var substr = parseunicode.substr(0,114)
            var urlTwitter = 'https://twitter.com/intent/tweet?text='+substr+length
            window.open(urlTwitter+' '+ url)
        }

    }

    sendLapor=(params)=> {
        var variable = {
            artikel : this.configKomentar.identifier, commentid: params.id, statusreport: params.type
        }
        const insert =
            'mutation commentReport($artikel: Int!, $commentid: Int!, $statusreport: Int!) { commentReport(artikel: $artikel, commentid: $commentid, statusreport: $statusreport){ status message } }';

        var urls = this.url_api_comment +'graphql'

        fetch(urls, {
            // "Access-Control-Allow-Origin" : "*",
            // "Access-Control-Allow-Credentials" : true,
            credentials: 'include',
            method: 'POST',
            headers: {
                 'Content-Type': 'application/json',
                 'Accept': 'application/json',
            },
            //mode: 'no-cors',
            // data : {
            //     artikel: params.artikel,
            //     commentid: params.id,
            //     statusreport: 0
            // },
            body: JSON.stringify({query: insert, variables: variable})
            // body: JSON.stringify({params})
        })
            .then( (response) => {
                return response.json()
            })
            .then((data) => {
            })
            .catch((reason) => {
                console.log('catch : ', reason);
            });


    }

    sendLike(id, parent_id){
        var variable = {artikel: this.configKomentar.identifier, commentid: id}
        var parent_type = ''
        var parent_input = ''
        if (parent_id != 0){
            variable['parent'] = parent_id
            parent_type = '$parent: Int!, '
            parent_input = 'parent: $parent, '
        }
        var query =
            'mutation commentLike($artikel: Int!, $commentid: Int!, '+parent_type+') { commentLike(artikel: $artikel, commentid: $commentid, '+parent_input+') { status message likeCount } }';

        var urls = this.url_api_comment +'graphql'

        fetch(urls, {
            // "Access-Control-Allow-Origin" : "*",
            // "Access-Control-Allow-Credentials" : true,
            credentials: 'include',
            //mode: 'no-cors',
            method: 'POST',
            headers: {
                 'Content-Type': 'application/json',
                 'Accept': 'application/json',
            },
            // data : {
            //     artikel: this.configKomentar.identifier,
            //     commentid: id
            // },
            body: JSON.stringify({query,variables:variable})
        })
            .then( (response) => {
                return response.json()
            })
            .then((data) => {
            })
            .catch((reason) => {
                console.log('catch : ', reason);
            });

    }

    fetchDataKomentarProkontra(page,sort,anchorpage,call_verified=false) {

         var getpage = page
         var sorting = sort
         var addpilred = ''
         var size = 10
         if (sorting == 'undefined') {
             page = 1
         }
         this.setFiltersProkontra = sort

         var query_var = [{name: "news.artikel", terms: this.configKomentar.identifier},
             {name: "news.site", terms: this.configKomentar.site}]
         var variabel_input = {
             type: "comment",
             prokontra: "1",
             size: size,
             query: query_var
         }
         if (this.isInt(sorting) === true) {
             var prokontraLabel_type = '$prokontraLabel : String!, '
             var prokontraLabel_input = 'prokontraLabel : $prokontraLabel, '
             variabel_input['prokontraLabel'] = sorting.toString()
         }else{
             var prokontraLabel_type = ''
             var prokontraLabel_input = ''
         }

         var anchor_type = ''
         var anchor_input = ''
         if (this.isInt(this.anchor) === true) {
             anchor_type = '$anchor: Int!, '
             anchor_input = 'idcomment: $anchor, '
             variabel_input['anchor'] = this.anchor
         } else if (this.isInt(anchorpage) === true) {
             anchor_type = '$anchor: Int!, '
             anchor_input = 'idcomment: $anchor, '
             variabel_input['anchor'] = anchorpage
         } else if (this.isInt(this.anchor) == true && this.isInt(anchorpage) == true) {
             anchor_type = '$anchor: Int!, '
             anchor_input = 'idcomment: $anchor, '
             variabel_input['anchor'] = anchorpage
         } else {
             anchor_type = '$anchor: Int!, '
             anchor_input = 'page: $anchor, '
             variabel_input['anchor'] = page
         }

         var query_string = 'query search($type: String!, $prokontra: String!, ' + prokontraLabel_type + '$size: Int!, ' + anchor_type + ' $query: [ElasticSearchAggregation]){search(type: $type, prokontra: $prokontra, ' + prokontraLabel_input + 'size: $size, ' + anchor_input + ' query: $query){' +
             'paging sorting counterPro counterKon profile hits { posisi results { id author content like prokontra prokontra_label status news create_date pilihanredaksi refer liker { id } reporter { id status_report } child { id child parent author content like prokontra status create_date pilihanredaksi refer liker { id } reporter { id status_report } authorRefer }  }  }  } } ';

         var urls = this.url_api_comment + 'graphql'
         fetch(urls, {
             credentials: 'include',
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
                 'Accept': 'application/json',
             },
             body: JSON.stringify({
                 query: query_string,
                 variables: variabel_input
             })
         })
             .then((status) => {
                 return status
             })
             .then((response) => {
                 const hasError = (response.status < 200 || response.status >= 300)
                 if (hasError) {
                     this.gagalload = true
                     throw response.text();
                 }
                  return response.json()
             })
                 .then((json) => {
                     if (json.data.search == null) {
                         this.gagalload = true
                         this.loadingRow = false
                     } else {
                         this.loadingRow = false
                         this.countCommentPro = json.data.search.counterPro
                         this.countCommentKon = json.data.search.counterKon
                         this.profile = json.data.search.profile
                         this.datastoresKomentar = json.data.search.hits.results
                         this.getDataVerifiedId = this.setVerifiedId(json.data.search.hits.results)
                         this.paging = json.data.search.paging
                         this.position = json.data.search.hits.posisi
                         if(call_verified){
                            var dataVerifiedId = this.getDataVerifiedId.map(function(data){return data})
                            var dataVerifiedIdPilred = this.getDataVerifiedIdPilred.map(function(data){return data})
                            var merge = dataVerifiedId.concat(dataVerifiedIdPilred)
                            var distinct = this.distincArray(merge)
                            this.fetchDataVerifiedUser(distinct)
                         }

                         // if(this.configKomentar.data_oa != null){
                         //     this.getAds(json.search.hits.posisi)
                         // }
                         if (this.formStore != '') {
                             setTimeout(() => {
                                 this.configKomentar.onscroll('#form0')
                                 this.configKomentar.onresize()
                             }, 700)
                         } else if (this.anchor != '') {
                             setTimeout(() => {
                                 // console.log(this.anchor);
                                 this.configKomentar.onscroll(this.anchor)
                                 this.configKomentar.onresize()
                             }, 800)
                         }
                     }
                     setTimeout(() => {
                         this.configKomentar.onresize()

                     }, 1000)
                 }).catch((error) => {

             })

         }

}
// var url = window.location.href;
// const anchor = Datastore.parsingURL(url)
// var datastore = window.datastore = new Datastore();
//
// export default datastore
// autorun(()=> datastore.fetchData())
// autorun(() => Datastore.fetchDataKomentar(1,'newest',45125302))



// WEBPACK FOOTER //
// ./static/src/component/datastore/datastore.js